import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { APP_NAME } from "@crewledger/shared/constants";
import { useAuth } from "@/features/auth/auth-provider";
import { BetaOnboardingWizard } from "@/features/beta-onboarding/beta-onboarding-wizard";

/** Beta allowlist onboarding — 5-step wizard to create a blank real workspace. */
export function BetaOnboardingPage() {
  const { ready, authenticated, provisioned, workspace, login } = useAuth();

  useEffect(() => {
    document.title = `Beta setup — ${APP_NAME}`;
  }, []);

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
        <div className="w-full max-w-md space-y-4 rounded-lg border bg-card p-6 text-center">
          <p className="text-sm text-muted-foreground">
            Sign in with your allowlisted work email to create a real Werkio workspace.
          </p>
          <button
            type="button"
            className="inline-flex h-10 w-full items-center justify-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground"
            onClick={login}
          >
            Continue with email
          </button>
        </div>
      </div>
    );
  }

  if (provisioned && workspace && !workspace.needsOnboarding) {
    return <Navigate to="/dashboard" replace />;
  }

  return <BetaOnboardingWizard />;
}
